import {
  generateCustomHeadersForTracking,
  generateHeadersByCookieValuesFilterByStartsWith,
  generateHeadersByCookieValuesFilterByEqual,
  generateStatsigHeaderByPageType,
} from '../../common/network/apiUtils';
import {allowedKeysForTolkien, hbAdultCookieKey} from '../../common/network/networkConstants';
import {STATSIG_PAGE_TYPES} from '../../utils/statsig';

import Config from '../../appConfig';

function categoryApiFactory(storefrontApiClient) {
  const categoryApi = {
    getCategoryProducts(params, cookies, headers) {
      return storefrontApiClient.get('/categorySearch', {
        headers: {
          ...headers,
          ...generateCustomHeadersForTracking(),
          ...generateHeadersByCookieValuesFilterByStartsWith(cookies, [allowedKeysForTolkien]),
          ...generateHeadersByCookieValuesFilterByEqual(cookies, [ hbAdultCookieKey]),
          ...generateStatsigHeaderByPageType(cookies, STATSIG_PAGE_TYPES.CATEGORY),
        },
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
    getIsGameConsole(params) {
      return storefrontApiClient.get('/checkForGameAndGameConsole', {
        headers: generateCustomHeadersForTracking(),
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
    getCategoryInformation(categoryId, params) {
      return storefrontApiClient.get(`/categories/${categoryId}`, {
        params,
        headers: generateCustomHeadersForTracking(),
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
    getKeywords(params) {
      return storefrontApiClient.get('/popularCategoryKeyword', {
        params,
        headers: generateCustomHeadersForTracking(),
        timeout: 1000,
      });
    },
    getCategoryRedirections(params) {
      return storefrontApiClient.get('/categoryRedirection', {
        headers: generateCustomHeadersForTracking(),
        params,
        timeout: Config.navigationTimeoutInMilliseconds,
      });
    },
  };

  return categoryApi;
}

export default categoryApiFactory;
